import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useContext } from 'react';
import { ComplexFilterContext } from './ComplexFilterContext';
import ComplexFilterRow from './ComplexFilterRow';

/**
 * A single AND group. Filters stack vertically; the "AND" chip in the header
 * keeps the boolean intent visible so operators don't have to remember the
 * precedence rules.
 */
const ComplexFilterGroup = ({ group }) => {
  const { createFilter, setFilter, removeFilterGroup } = useContext(ComplexFilterContext);
  const { groupId } = group;
  const filterEntries = Object.entries(group.filters);

  return (
    <Card variant="outlined" sx={{ borderRadius: 1.5 }}>
      <CardContent sx={{ pb: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          sx={{ mb: 1.5 }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip size="small" label="AND" color="default" variant="outlined" />
            <Box sx={{ fontSize: 12, color: 'text.secondary' }}>
              {filterEntries.length} filter{filterEntries.length === 1 ? '' : 's'} — all
              must match.
            </Box>
          </Stack>
          <Tooltip title="Remove this group">
            <IconButton
              size="small"
              color="error"
              onClick={() => removeFilterGroup(groupId)}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>

        <Stack spacing={1.5}>
          {filterEntries.map(([filterId, filter]) => (
            <ComplexFilterRow key={filterId} groupId={groupId} filter={filter} />
          ))}
        </Stack>

        <Box sx={{ mt: 1.5 }}>
          <Button
            size="small"
            variant="text"
            startIcon={<AddIcon />}
            onClick={() => {
              const filter = createFilter();
              setFilter(groupId, filter.filterId, filter);
            }}
          >
            Add filter
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export { ComplexFilterGroup as default };
